import { render, staticRenderFns } from "./CrashBetElement.vue?vue&type=template&id=43b90806&scoped=true"
import script from "./CrashBetElement.vue?vue&type=script&lang=js"
export * from "./CrashBetElement.vue?vue&type=script&lang=js"
import style0 from "./CrashBetElement.vue?vue&type=style&index=0&id=43b90806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b90806",
  null
  
)

export default component.exports